<template>
  <div :class="[$shTemplateStyle.headerItemContainer, $style.container]">
    <div :class="$shTemplateStyle.infoContainer">
      <div :class="$shTemplateStyle.label">{{ $t('code') }}:</div>
      <div :class="$shTemplateStyle.text">
        {{ joinCode }}
      </div>
    </div>
    <div :class="$style.actionsContainer">
      <div :title="$t('copy-code')" :class="[$style.action, $style.actionLeft]" @click="copyJoinCode">
        <img :src="copyIcon" alt="Copy" />
      </div>
      <div :title="$t('share-code')" :class="[$style.action, $style.actionRight]" @click="shareJoinCode">
        <img :src="shareIcon" alt="Share" />
      </div>
    </div>
  </div>
</template>

<script>
import CopyIcon from "@/assets/icons/copy.svg";
import ShareIcon from "@/assets/icons/share.svg";
import { toast } from "vue3-toastify";
import styles from "@/css/JoinCodeBox.module.css";
import globalStyles from "@/css/global.module.css";
import secondaryHeaderTemplateStyles from "@/css/SecondaryHeaderTemplate.module.css";

export default {
  components: {},
  name: "JoinCodeBox",
  props: {
    joinCode: {
      type: String,
      required: true,
      default: "",
    },
  },
  data() {
    return {
      copyIcon: CopyIcon,
      shareIcon: ShareIcon,
    };
  },
  computed: {
    $style() {
      return styles;
    },
    $globalStyle() {
      return globalStyles;
    },
    $shTemplateStyle() {
      return secondaryHeaderTemplateStyles;
    },
  },
  methods: {
    copyJoinCode() {
      navigator.clipboard
        .writeText(this.joinCode)
        .then(() => {
          toast(this.$t("copy-success"), { type: "success" });
        })
        .catch((err) => {
          console.error("Failed to copy: ", err);
          toast(this.$t("copy-error"), { type: "error" });
        });
    },
    shareJoinCode() {
      if (navigator.share) {
        navigator
          .share({
            title: this.$t("share-title"),
            text: this.$t("share-text", { code: this.joinCode }),
          })
          .catch((err) => {
            console.error("Error sharing:", err);
            toast(this.$t("share-error"), { type: "error" });
          });
      } else {
        toast(this.$t("share-not-supported"), { type: "error" });
      }
    },
  },
};
</script>

<style scoped></style>
